import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-3 md:py-4 px-3 relative overflow-hidden border-b-4 border-[#D4A843]" data-id="element-62">
      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-63">
        <h1 className="text-3xl md:text-5xl font-black text-[#1F3D2B] leading-tight mb-1 uppercase tracking-tight" data-id="element-64">
          🌾⚖️ Todo tu año de agro <span className="text-[#D4A843]" data-id="element-65">listo</span>
        </h1>

        <div className="my-1 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 w-full max-w-lg" onClick={scrollToPricing} data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/pjrw62pc6uoqLyYjLEbGN1/mockups_gestion_agropecuaria.png" alt="Kit Completo Gestión Agropecuaria" className="w-full h-auto drop-shadow-2xl" data-id="element-67" />
        </div>

        <p className="text-gray-700 text-sm md:text-base font-bold mb-1 max-w-xl mx-auto leading-snug" data-id="element-68">
          Clases, contenidos, casos reales, legislación y gestión agropecuaria
          ya armados para que dejes de improvisar.
        </p>

        <div className="bg-[#F5F0E6] border-2 border-[#D4A843] rounded-lg px-4 py-1.5 mb-2 inline-block" data-id="element-69">
          <p className="text-[#1F3D2B] font-black text-sm md:text-base" data-id="element-70">
            👉 Llegás al aula sabiendo exactamente qué enseñar.
          </p>
        </div>

        <div className="flex justify-center mb-2 w-full max-w-sm" data-id="element-71">
          <CTAButton onClick={scrollToPricing} variant="primary" fullWidth className="py-3 text-sm md:text-base" data-id="element-72">
            SÍ, QUIERO MIS CLASES RESUELTAS
          </CTAButton>
        </div>

        <div className="inline-block bg-[#F5F6F7] border border-gray-300 rounded-full px-3 py-1" data-id="element-73">
          <p className="text-gray-600 text-xs md:text-sm font-bold flex items-center gap-1.5" data-id="element-74">
            <span className="text-[#D4A843] text-sm" data-id="element-75">★★★★★</span>
            +300 docentes ya usan este sistema
          </p>
        </div>
      </div>
    </section>;
}